import { render, staticRenderFns } from "./Metric.global.vue?vue&type=template&id=7bae1244&scoped=true&lang=pug&"
import script from "./Metric.global.vue?vue&type=script&lang=ts&"
export * from "./Metric.global.vue?vue&type=script&lang=ts&"
import style0 from "./Metric.global.vue?vue&type=style&index=0&id=7bae1244&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "7bae1244",
  null
  
)

export default component.exports